export enum ScreenSizes {
  xs = 0,
  sm = 599,
  md = 959,
  lg = 1279,
  xl = 1559,
  xxl = 1919,
  xxxl = 2999
}
